<template>
  <div v-loading="listLoading" class="app-container">
    <div>
      <div class="feet-s">
        <div class="feet-r">
          <!--导出-->
          <el-button
            v-if="$store.getters.button_permissions.includes('btn:finance:accountsPayableReview:billReview:export') || $store.getters.button_permissions.includes('btn:finance:accountsPayableReview:trunkLine:export')"
            size="small" type="primary"
            @click="operationBtn"
          >{{ $t('receivablePayable.Export') }}</el-button>

          <!--自定义栏目-->
          <CustomStatusBar :payable-type="payableType" />

          <TipsCmp :row="statisticalData" />
        </div>
        <!--查询-->
        <el-button
          icon="el-icon-search" size="small" type="primary"
          @click="searchResources"
        >{{ $t('receivablePayable.Search') }}</el-button>
      </div>

      <el-divider />

      <el-table
        ref="table"
        :key="tableKey"
        :data="tableData"
        :height="tableHeightRow.height"
        class="table-height"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55" />
        <el-table-column :label="$t('operationCenter.ind')" align="center" width="60px">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in diffCustomColumn"
          :key="index"
          :align="item.fixed"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'businessType'">
              <!--揽收-->
              <span v-if="scope.row.businessType === 2">{{ $t('collectionCenter.lanshou') }}</span>
              <!--派送-->
              <span v-else-if="scope.row.businessType === 3">{{ $t('collectionCenter.dispatch') }}</span>
              <!--转运-->
              <span v-else-if="scope.row.businessType === 1">{{ $t('collectionCenter.turnTransport') }}</span>
            </div>

            <div v-else-if="item.prop === 'collectType'">
              <!--1 上门交件 2 上门揽收-->
              {{ scope.row.collectType === 1
                ? $t('collectionCenter.dropOff')
                : scope.row.collectType === 2 ? $t('collectionCenter.doorPickUp') : ''
              }}
            </div>

            <!-- 商户号(商家编码)-->
            <div v-else-if="item.prop === 'merchantCode'">
              {{ scope.row[item.prop] }}{{ scope.row['merchantName']?`(${scope.row['merchantName']})`:'' }}
            </div>

            <!--AJD显示账号类型 customerType 1 自营 2 第三方-->
            <div v-else-if="item.prop === 'customerType'">
              {{ scope.row.customerType === 1
                ? $t('GlobalSetObj.selfSupport')
                : scope.row.customerType === 2 ? $t('GlobalSetObj.three') : ''
              }}
            </div>

            <!--运输类型-->
            <div v-else-if="item.prop === 'routeType'">
              {{
                TRANSPORTATION_TYPE[scope.row.routeType] && TRANSPORTATION_TYPE[scope.row.routeType].label || ''
              }}
            </div>

            <!-- 来源 -->
            <div v-else-if="item.prop === 'feeSource'">{{ FEE_SOURCE[scope.row.feeSource] && FEE_SOURCE[scope.row.feeSource].label || '' }}</div>

            <!-- 货物类型-->
            <div v-else-if="item.prop === 'cargoType'">{{ CARGO_TYPE[scope.row.cargoType] && CARGO_TYPE[scope.row.cargoType].label || '' }}</div>

            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in getCurrentColumns"
          :key="ind + 100"
          :align="item.fixed"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getCurrentExamineTableData"
          @size-change="getSizeExamineTableData"
        />
      </div>
    </div>

    <!--  查询  -->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.Search')"
      :visible.sync="showSearch"
      custom-class="drawerClass"
      direction="rtl"
      size="50%"
    >
      <search-form
        :is-read-only="true"
        :select-key="selectKey"
        :payable-type="payableType"
        :bill-batch-number="batchNumber"
        @search="searchFun"
        @close="showSearch = false"
      />
    </el-drawer>
  </div>
</template>

<script>
import {
  apiPayableSiteExpenseCountTotalFree,
  apiPayableTransportExpenseCountTransport,
  apiPayableSiteExpenseExport,
  apiPayableTransportExpenseExport,
  apiPayableSiteExpenseGetPage,
  apiPayableTransportExpenseGetPage
} from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
import { goFinanceExportPage } from '@/utils/goExportList.js';
import { CARGO_TYPE, FEE_SOURCE, ORDER_TYPE_LIST, WAYBILL_STATUS } from '@/views/finance/enums.js';
import { SEARCH_PARAMS } from '@/views/finance/payableManage/feesPayable/enums.js';
import { TRANSPORTATION_TYPE } from '@/views/finance/utils';
import { commonMinXin } from '@/views/finance/payableManage/feesPayable/commonMInXin';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';

export default {
  name: 'BatchNumberDetail',
  components: {
    searchForm: () => import('@/views/finance/payableManage/feesPayable/component/QuerySearchCmp.vue'),
    CustomStatusBar: () => import('@/views/finance/cmp/CustomStatusBar.vue'),
    TipsCmp: () => import('./TipsCmp.vue')
  },
  mixins: [commonMinXin, estimateTableHeight],

  props: {
    // 批次号
    batchNumber: {
      type: String,
      default: ''
    },
    // 列详情
    billBatchData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 1 审核 2 核付详情
    selectKey: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      TRANSPORTATION_TYPE, // 运输类型
      WAYBILL_STATUS, // 物流订单
      ORDER_TYPE_LIST, // 揽收订单
      queryForm: {
        orderDirection: 'DESC',
        pageNumber: 1,
        pageSize: 10,
        params: {
          ...SEARCH_PARAMS
        }
      },
      listLoading: false,
      total: 0,
      tableData: [],
      // currentColumns: [],
      getCurrentColumns: [],
      selectData: [],
      showSearch: false,

      // 详情统计数据
      statisticalData: {
        providerName: 0, // 应付主体
        siteName: 0, // 应付网点
        totalFree: 0, // 总费用
        totalFeeQty: 0, // 总票数
        averageFee: 0 // 平均每票费用
      },
      payableType: '' // 账单类型-用于自定义栏目
    };
  },
  computed: {
    FEE_SOURCE() {
      return FEE_SOURCE;
    },
    CARGO_TYPE() {
      return CARGO_TYPE;
    }
  },
  watch: {
    billBatchData: {
      handler(val) {
        console.log(val, '详情数据');
        this.payableType = val.payableType;
        this.upData(val);
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    // 更新数据
    upData() {
      if (this.selectKey === 1) {
        this.queryForm.params.billBatchNumber = this.batchNumber;
      } else {
        this.queryForm.params.payableNumber = this.batchNumber;
      }
      this.getExamineTableData();
      this.asyncApiPayableSiteExpenseCountTotalFree();
    },
    // 翻页
    getCurrentExamineTableData(val) {
      this.queryForm.pageNumber = val;
      this.getExamineTableData();
    },
    // 每页显示数量变化
    getSizeExamineTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getExamineTableData();
    },

    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },
    // 导出
    operationBtn() {
      const ids = [];
      this.selectData.map(list => {
        ids.push(list.id);
      });
      const prop = [];
      const label = [];
      this.diffCustomColumn.map(item => {
        if (item.prop !== 'customerAlias') {
          prop.push(item.prop);
          label.push(item.label);
        }
      });
      const param = {
        ...this.queryForm.params,
        fieldList: prop,
        headList: label,
        ids: ids
      };
      const API = this.payableType === 5 ? apiPayableTransportExpenseExport : apiPayableSiteExpenseExport;
      API(param).then(res => {
        if (res.code === 200) {
          return goFinanceExportPage();
        }
      }).then(res => {
        if (res) {
          this.$emit('closeDetail');
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 打开查询弹窗
    searchResources() {
      this.showSearch = true;
    },

    // 查询
    searchFun(params) {
      console.log(params, '搜索数据');
      this.showSearch = false;
      this.queryForm.pageNumber = 1;
      this.queryForm.params = params;
      this.getExamineTableData();
      this.asyncApiPayableSiteExpenseCountTotalFree();
    },
    // 获取列表
    getExamineTableData() {
      const params = cloneDeep(this.queryForm);
      params.params.payableType = this.payableType;
      console.log(params, '详情参数1');
      this.getCurrentColumns = [];
      this.listLoading = true;
      // 获取列表数据 payableType 账单类型
      const API = this.payableType === 5 ? apiPayableTransportExpenseGetPage : apiPayableSiteExpenseGetPage;
      API(params, false).then(resp => {
        if (resp.code === 200) {
          this.tableData = resp.data.map(arr => {
            // 物流订单 WAYBILL_STATUS    揽收订单 ORDER_TYPE_LIST
            // 应付的业务类型是揽收的取揽收订单的状态，业务类型是派送的取快递物流订单的状态
            if ((arr.businessType === 3) && arr.status) {
              /**
               * 1、业务类型 businessType 为 3，订单状态展示【物流订单】的运单状态
               */
              const s1 = this.WAYBILL_STATUS.find(item => item.code === arr.status) || '';
              arr.status = s1.label;
            } else if (arr.businessType === 2 && arr.status) {
              /**
               * 2、业务类型 businessType 为 2，订单状态展示【揽收订单】的订单状态
               */
              const s2 = this.ORDER_TYPE_LIST.find(item => item.collectStatus === arr.status) || '';
              arr.status = s2.collectStatusName;
            } else {
              arr.status = '';
            }
            return arr;
          });
          this.total = resp.total;
          if (resp.data.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                label: item.label,
                width: 200,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
            });
            this.$nextTick(() => {
              this.$refs.table.doLayout();
              this.rowSelectFlag = true;
              this.tableData.map(list => {
                const matchedIndex = this.selectData.findIndex(itemList => itemList.id === list.id);
                this.$refs.table.toggleRowSelection(list, matchedIndex !== -1);
              });
              this.rowSelectFlag = false;
            });
          }
        }
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.listLoading = false;
      });
    },
    // 获取详情总数据
    asyncApiPayableSiteExpenseCountTotalFree() {
      const { params } = this.queryForm;
      const { billBatchNumber, payableNumber } = params;
      console.log(params, '详情参数2');
      const formData = this.selectKey === 1 ? { billBatchNumber } : { payableNumber };
      const API = this.payableType === 5 ? apiPayableTransportExpenseCountTransport : apiPayableSiteExpenseCountTotalFree;
      API(formData).then(res => {
        const data = res.data || {};
        const { providerName, siteName, totalFree, totalFeeQty, averageFee, totalFee } = data;

        Object.assign(this.statisticalData, {
          providerName,
          siteName: siteName || '-',
          totalFree: totalFree || totalFee || 0,
          totalFeeQty: totalFeeQty || 0,
          averageFee: averageFee || 0
        });
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .app-container {
    padding: 10px;
  }
</style>
